import { AppSwitchBox } from 'components';
import usePlans from 'hooks/API/GET/usePlans';
import { Fragment } from 'react';

function PlansSelector({ enableAPI, selectedValues = [], handleChange, dependencies = {} }) {
  const { query = '' } = dependencies;
  const queryParams = `?mode=dropdown${query ? `&${query}` : ``}`;

  const { data, isLoading, isError } = usePlans({ enabled: enableAPI, queryParams });

  return (
    <Fragment>
      {isLoading ? (
        'Fetching plans'
      ) : isError ? (
        'Failed to load plans'
      ) : (
        <Fragment>
          {data?.data?.length > 0 ? (
            <Fragment>
              {data?.data?.map((plan) => {
                return (
                  <AppSwitchBox
                    key={plan._id}
                    inputProps={{
                      name: plan.name,
                      checked: selectedValues.includes(plan._id),
                      onChange: (event) => handleChange(plan, event),
                    }}
                    labelProps={{
                      label: plan.name,
                    }}
                  />
                );
              })}
            </Fragment>
          ) : null}
        </Fragment>
      )}
    </Fragment>
  );
}

export default PlansSelector;
